import { IconProps } from "../../utils/global-types/global-types";

const StatusIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_10284_106893)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6556 2.35H7.00559C5.90377 2.35 5.01059 3.2432 5.01059 4.345V5.01H4.34559C3.24377 5.01 2.35059 5.9032 2.35059 7.005V13.655C2.35059 14.7568 3.24377 15.65 4.34559 15.65H10.9956C12.0974 15.65 12.9906 14.7568 12.9906 13.655V12.99H13.6556C14.7574 12.99 15.6506 12.0968 15.6506 10.995V4.345C15.6506 3.2432 14.7574 2.35 13.6556 2.35ZM10.5308 8.734L7.53759 12.724C7.41437 12.8892 7.22119 12.9872 7.0154 12.99C6.81097 12.9928 6.61498 12.9004 6.48619 12.7408L5.15619 11.0776C4.92657 10.7906 4.97278 10.372 5.25979 10.1438C5.5468 9.9142 5.9654 9.9604 6.19498 10.2474L6.98877 11.2386L9.46539 7.936C9.68657 7.642 10.1038 7.5832 10.3978 7.803C10.6904 8.0228 10.7506 8.44 10.5308 8.734ZM14.3206 10.995C14.3206 11.3618 14.0224 11.66 13.6556 11.66H12.9906V7.005C12.9906 5.9032 12.0974 5.01 10.9956 5.01H6.34059V4.345C6.34059 3.9782 6.63877 3.68 7.00559 3.68H13.6556C14.0224 3.68 14.3206 3.9782 14.3206 4.345V10.995Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10284_106893">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StatusIcon;
